import React from 'react'

function prependZero(value) {
  return (value > 9 ? '' : '0') + value
}

let date

function formatDate() {
  const mm = prependZero(date.getMonth() + 1) // getMonth() is zero-based
  const dd = prependZero(date.getDate())

  const d = [dd, mm, date.getFullYear()].join('.')

  const hours = prependZero(date.getHours())
  const minutes = prependZero(date.getMinutes())
  const seconds = prependZero(date.getSeconds())

  const s = [hours, minutes, seconds].join(':')

  return `${d} ${s}`
}

const ServerTimeTicker = ({ currentDate }) => {
  const ref = React.useRef()

  React.useLayoutEffect(() => {
    date = new Date(currentDate)

    const interval = setInterval(() => {
      date.setSeconds(date.getSeconds() + 1)
      ref.current.innerText = formatDate()
    }, 1000)

    return () => {
      clearInterval(interval)
    }
  }, []) // eslint-disable-line react-hooks/exhaustive-deps

  return <span ref={ref} />
}

export default ServerTimeTicker
